import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkspaceState } from './state';

export const WorkspacesFeature = 'workspaces';

export const workspacesFeatureStateSelector =
  createFeatureSelector<WorkspaceState>(WorkspacesFeature);

export const selectWorkspaces = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.workspaces,
);

export const selectWorkspacesLoading = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.loadingworkspaces,
);

export const selectWorkspaceCreating = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.creatingWorkspace,
);

export const selectCloseCreatingWorkspaceModal = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.closeCreatingWorkspaceModal,
);

export const selectWorkspaceDetails = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.workspaceDetails,
);

export const selectReferenceDocument = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.referenceDocument,
);

export const selectNonReferenceDocuments = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.nonReferenceDocuments,
);

export const selectReviewDoneWithErrors = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.reviewDoneWithErrors,
);

export const selectLoadingReviewData = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.loadingReviewData,
);

export const selectLoadingReviewDataComplete = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.loadingReviewDataComplete,
);

export const selectCurrentReviewPageByDocumentId = (documentId: string) =>
  createSelector(
    workspacesFeatureStateSelector,
    (state: WorkspaceState) => state.currentReviewPageByDocumentId[documentId] ?? 1,
  );

export const selectTotalReviewPagesByDocumentId = (documentId: string) =>
  createSelector(
    workspacesFeatureStateSelector,
    (state: WorkspaceState) => state.totalReviewPagesByDocumentId[documentId] ?? 1,
  );

export const selectCurrentReviewPageByDocumentIdMap = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.currentReviewPageByDocumentId,
);

export const selectTotalReviewPagesByDocumentIdMap = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.totalReviewPagesByDocumentId,
);

export const selectReviewedPagesByDocumentIdMap = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.reviewedReviewPagesByDocumentId,
);

export const selectPagedReviewDataByDocumentIdMap = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.pagedReviewDataByDocumentId,
);

export const selectTotalReviewPagesAllDocuments = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.totalReviewPagesAllDocuments,
);

export const selectTotalReviewedPagesAllDocuments = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.totalReviewedPagesAllDocuments,
);

export const selectReviewProgressPercentAllDocuments = createSelector(
  selectTotalReviewedPagesAllDocuments,
  selectTotalReviewPagesAllDocuments,
  (reviewedPages, totalPages) => {
    if (!totalPages) {
      return 0;
    }

    return Math.min(Math.round((reviewedPages / totalPages) * 100), 100);
  },
);

export const selectWorkspaceDetailsLoading = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.loadingWorkspaceDetails,
);

export const selectWorkspaceRenaming = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.renaminWorkspace,
);

export const selectCloseRenamingWorkspaceModal = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.closeRenamingWorkspaceModal,
);

export const selectAddingWorkspaceDocuments = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.addingWorkspaceDocuments,
);

export const selectCloseAddingWorkspaceDocumentsModal = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.closeAddingWorkspaceDocumentsModal,
);

export const selectAnalyzingClauseVariance = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.analyzingClauseVariance,
);

export const selectAnalyzingClauseVarianceResponse = createSelector(
  workspacesFeatureStateSelector,
  (state: WorkspaceState) => state.analyzingClauseVarianceResponse,
);
